<div class="panel panel-primary">
    @if (Loading) {
        <div class="loading"></div>
    }
    <div class="panel-heading">
        Purchase Order - {{ PO.CreatedBy?.UserName }}
        <div class="pull-right">
            <nz-space-compact>
                @if (HasStepPermission(PO.StepID)) {
                    <button nz-button class="pf-form-action" (click)="Update()">
                        <span class="fa-solid fa-floppy-disk"></span>Save
                    </button>
                }
                @if (HasStepPermission(PO.StepID) && PO.ApproveVisible) {
                    <button nz-button class="pf-form-action" (click)="ApproveItem(PO)">
                        <img src="assets/images/ptp/approve.png" alt="" />Approve
                    </button>
                }
                @if (HasStepPermission(PO.StepID) && PO.DenyVisible) {
                    <button nz-button class="pf-form-action" (click)="DenyItem(PO, denyModal)">
                        <img src="assets/images/ptp/deny.png" alt="" />Deny
                    </button>
                }
                @if (!HasStepPermission(PO.StepID) || !PO.ApproveVisible) {
                    <button nz-button class="pf-form-action" (click)="CloseWindow($event)">Close</button>
                }
            </nz-space-compact>
        </div>
    </div>
    <div class="panel-body">
        <div class="panel panel-default">
            <div class="panel-heading">General Information</div>
            <div class="panel-body">
                <div role="form" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-2 control-label">PO #</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                readonly="readonly"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.PONumber"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Created Date</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                readonly="readonly"
                                [ngModelOptions]="{standalone: true}"
                                [ngModel]="CreateDateDisplay"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label {{ getErrorStatus() }}">
                            <span style="color: red">*</span> Location
                        </div>
                        <div class="col-md-4 {{ getErrorStatus() }}">
                            <select
                                class="form-control"
                                name="location"
                                required
                                [(ngModel)]="PO.Location"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="SelectPOLocation()">
                                <option value=""></option>
                                @for (location of Locations; track location) {
                                    <option [ngValue]="location.PTPShippingLocationID">
                                        {{ location.ShippingLocation }}
                                    </option>
                                }
                            </select>
                            @if (HasLocationError) {
                                <span class="text-danger">Please choose a Location</span>
                            }
                        </div>
                        <div class="col-md-2 control-label">Department</div>
                        <div class="col-md-4">
                            <select
                                class="form-control"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.Department">
                                @for (department of Departments; track department) {
                                    <option [ngValue]="department.DepartmentID">
                                        {{ department.DepartmentName }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label {{ getErrorStatus() }}">
                            <span style="color: red">*</span> Vendor Number
                        </div>
                        <div class="col-md-4 {{ getErrorStatus() }}">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.VendorNumber"
                                (keyup)="ValidateVendorNumber()"
                                #venNum="ngModel"
                                required
                                class="form-control" />
                            @if (HasVendorNumberError) {
                                <span class="text-danger">Vendor Number is Required</span>
                            }
                        </div>
                        <div class="col-md-2 control-label">Vendor Invoice #</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.VendorInvoiceNumber"
                                class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        @if (PO.PurchaseRequest) {
            <div class="panel panel-default">
                <div class="panel-heading">Purchase Request Information</div>
                <div class="panel-body">
                    <div role="form" class="form-horizontal">
                        <div class="form-group">
                            <div class="col-md-2 control-label">Created By</div>
                            <div class="col-md-4">
                                <input
                                    type="text"
                                    readonly="readonly"
                                    [value]="$safeNavigationMigration(PO.PurchaseRequest.CreatedBy?.UserName)"
                                    class="form-control" />
                            </div>
                            <div class="col-md-2 control-label">Created Date</div>
                            <div class="col-md-4">
                                <input
                                    type="text"
                                    readonly="readonly"
                                    [value]="PrCreateDateDisplay"
                                    class="form-control" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="panel panel-default">
            <div class="panel-heading">Vendor Contact Information</div>
            <div class="panel-body">
                <div role="form" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-2 control-label {{ getErrorStatus() }}">
                            <span style="color: red">*</span> Vendor Name
                        </div>
                        <div class="col-md-4 {{ getErrorStatus() }}">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.VendorName"
                                (keyup)="ValidateVendorName()"
                                required
                                #venName="ngModel"
                                class="form-control" />
                            @if (HasVendorNameError) {
                                <span class="text-danger">Vendor Name is Required</span>
                            }
                        </div>
                        <div class="col-md-2 control-label">Vendor Contact</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.VendorContact"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Contact Address 1</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ContactAddressLine1"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Contact Address 2</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ContactAddressLine2"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Contact City</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ContactCity"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Contact State</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ContactState"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Contact ZIP</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ContactZip"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Contact Email</div>
                        <div class="col-md-2">
                            <input
                                type="email"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ContactEmail"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Contact Phone</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ContactPhone"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Contact Fax</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ContactFax"
                                class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel panel-default">
            <div class="panel-heading">Shipping Information</div>
            <div class="panel-body">
                <div role="form" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-2 control-label">Load Shipping Location</div>
                        <div class="col-md-4">
                            <select
                                class="form-control"
                                [(ngModel)]="ShippingLocation"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="SelectLocation()">
                                <option value="" [ngValue]="" selected></option>
                                @for (s of ShippingLocations; track s) {
                                    <option [ngValue]="s">
                                        {{ s.ShippingLocation }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Ship To Address 1</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ShipToAddressLine1"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To Address 2</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ShipToAddressLine2"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Ship To City</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ShipToCity"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To State</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ShipToState"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To Postal Code</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ShipToZip"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Ship To Email</div>
                        <div class="col-md-2">
                            <input
                                type="email"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ShipToEmail"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To Phone</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ShipToPhone"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To Country</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PO.ContactInformation.ShipToCountry"
                                class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel panel-default">
            <div id="lineitems" class="panel-heading">
                Line Items
                <div class="pull-right">
                    <button
                        class="btn btn-default"
                        style="padding: 2px 8px; margin-top: -2px"
                        (click)="ShowCreateWindow(createLineItem)">
                        <span class="fa-solid fa-plus"></span>
                    </button>
                </div>
            </div>
            <div class="panel-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Total</th>
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of PO.LineItems; track item) {
                            <tr>
                                <td>
                                    <!-- Display mode -->
                                    @if (!item.edit) {
                                        <span>{{ item.Description }}</span>
                                    }
                                    <!-- Edit mode -->
                                    @if (item.edit) {
                                        <input nz-input [(ngModel)]="item.Description" type="text" />
                                    }
                                </td>
                                <td>
                                    <!-- display mode -->
                                    @if (!item.edit) {
                                        <span>{{ item.Quantity }}</span>
                                    }
                                    <!-- edit mode -->
                                    @if (item.edit) {
                                        <input nz-input [(ngModel)]="item.Quantity" type="number" />
                                    }
                                </td>
                                <td>
                                    <!-- display mode -->
                                    @if (!item.edit) {
                                        <span>{{ item.Price | currency }}</span>
                                    }
                                    <!-- edit mode -->
                                    @if (item.edit) {
                                        <input nz-input [(ngModel)]="item.Price" type="number" />
                                    }
                                </td>
                                <td>{{ item.Price * item.Quantity | currency }}</td>
                                <td>
                                    <!-- display mode (edit icon) -->
                                    @if (!item.edit) {
                                        <button
                                            class="btn btn-default"
                                            style="padding: 2px 8px"
                                            (click)="item.edit = !item.edit">
                                            <span class="fa-solid fa-pen-to-square"></span>
                                        </button>
                                    }
                                    <!-- edit mode (save icon) -->
                                    @if (item.edit) {
                                        <button class="btn btn-default" style="padding: 2px 8px" (click)="Update()">
                                            <span class="fa-solid fa-floppy-disk"></span>
                                        </button>
                                    }
                                </td>
                                <td>
                                    <button class="btn btn-danger" style="padding: 2px 8px" (click)="RemoveItem(item)">
                                        <span class="fa-solid fa-trash"></span>
                                    </button>
                                </td>
                            </tr>
                        }
                        <tr style="border-top: 2px double black">
                            <td><b>TOTAL</b></td>
                            <td></td>
                            <td></td>
                            <td>
                                <b>{{ GetLinesItemTotal() | currency }}</b>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- original purchase request information -->
        @if (PO.PurchaseRequest?.Notes.length > 0 || PO.PurchaseRequest?.Attachments.length > 0) {
            <div class="panel panel-default">
                <div class="panel-heading">Vendor Information From Request</div>
                <div class="panel-body">
                    <div class="form-horizontal" role="form">
                        @if (PO.PurchaseRequest?.Notes.length > 0) {
                            <div class="form-group">
                                <div class="col-md-2 control-label">Notes</div>
                                <div class="col-md-10">
                                    <div
                                        class="form-control"
                                        style="height: 200px; overflow: auto"
                                        [innerHTML]="BuildNotesTable(PO.PurchaseRequest)"></div>
                                </div>
                            </div>
                        }
                        @if (PO.PurchaseRequest?.Attachments.length > 0) {
                            <div class="form-group">
                                <div class="col-md-2 control-label">Attachments</div>
                                <div class="col-md-10">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>File Name</th>
                                                <th>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (attach of PO.PurchaseRequest?.Attachments; track attach) {
                                                <tr>
                                                    <td>
                                                        <a
                                                            style="cursor: pointer"
                                                            (click)="OpenAttachment(attach.PurchaseRequestAttachmentID)"
                                                            >{{ attach.FileName }}
                                                        </a>
                                                    </td>
                                                    <td>{{ attach.Description }}</td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        <!-- end of original purchase request information -->
        <div class="panel panel-default">
            <div id="notes" class="panel-heading">
                Notes
                <div class="pull-right">
                    <button
                        class="btn btn-default"
                        style="padding: 2px 8px; margin-top: -2px"
                        (click)="ShowCreateWindow(createNote)">
                        <span class="fa-solid fa-plus"></span>
                    </button>
                </div>
            </div>
            <div class="panel-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Time</th>
                            <th>Author</th>
                            <th>Note</th>
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (note of PO.Notes; track note) {
                            <tr>
                                <td>
                                    {{
                                        (note.ID === 0 ? note.NoteTime : note.NoteTime + "Z")
                                            | date: "MM/dd/yyyy h:mm a"
                                    }}
                                </td>
                                <td>
                                    {{ note.UserName }}
                                </td>
                                <td>
                                    <!-- display mode -->
                                    @if (!note.edit) {
                                        <span>{{ note.Note }}</span>
                                    }
                                    <!-- edit mode -->
                                    @if (note.edit) {
                                        <textarea [(ngModel)]="note.Note" class="form-control" style="height: auto">{{
                                            note.Note
                                        }}</textarea>
                                    }
                                </td>
                                <td>
                                    <!-- display mode (edit icon) -->
                                    @if (note.ID === 0 && !note.edit) {
                                        <button
                                            class="btn btn-default"
                                            style="padding: 2px 8px"
                                            (click)="note.edit = !note.edit">
                                            <span class="fa-solid fa-pen-to-square"></span>
                                        </button>
                                    }
                                    <!-- edit mode (save icon) -->
                                    @if (note.ID === 0 && note.edit) {
                                        <button
                                            class="btn btn-default"
                                            style="padding: 2px 8px"
                                            (click)="note.edit = !note.edit">
                                            <span class="fa-solid fa-floppy-disk"></span>
                                        </button>
                                    }
                                </td>
                                <td>
                                    @if (note.ID === 0) {
                                        <button
                                            class="btn btn-danger"
                                            style="padding: 2px 8px"
                                            (click)="RemoveNote(note)">
                                            <span class="fa-solid fa-trash"></span>
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <ng-template #createLineItem>
        <div class="modal-header">Create Line Item</div>
        <form #createLineForm="ngForm" (ngSubmit)="AddItem(createLineForm, NewRequest)" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <label for="desc">Description</label>
                    <input
                        type="text"
                        name="desc"
                        [(ngModel)]="NewRequest.Description"
                        class="form-control"
                        placeholder="Enter description"
                        required />
                </div>
                <div class="form-group">
                    <label for="qty">Quantity</label>
                    <input
                        type="number"
                        name="qty"
                        [(ngModel)]="NewRequest.Quantity"
                        class="form-control"
                        placeholder="Enter quantity"
                        required />
                </div>
                <div class="form-group">
                    <label for="price">Price</label>
                    <input
                        type="number"
                        step="0.01"
                        name="price"
                        [(ngModel)]="NewRequest.Price"
                        class="form-control"
                        placeholder="Enter price"
                        required />
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-default">Create</button>
            </div>
        </form>
    </ng-template>

    <ng-template #createNote>
        <div class="modal-header">Add Note</div>
        <form id="addNoteForm" [noValidate]="false" (submit)="addNote()" action="#" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <label for="note">Note</label>
                    <textarea
                        [formControl]="NoteField"
                        class="form-control"
                        style="height: 100px; margin-bottom: 15px"
                        required></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-default">Submit</button>
            </div>
        </form>
    </ng-template>

    <ng-template #denyModal>
        <div class="modal-header">Deny {{ this.DenyRequest.DenyType === 0 ? "Request" : "Order" }}</div>
        <form (ngSubmit)="DoDenyItem()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <label for="denyNotes">Reason (optional)</label>
                    <textarea
                        name="denyNotes"
                        [(ngModel)]="DenyRequest.DenyNotes"
                        [ngModelOptions]="{standalone: true}"
                        class="form-control"
                        style="height: 100px; margin-bottom: 15px"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-danger">
                    Deny {{ this.DenyRequest.DenyType === 0 ? "Request" : "Order" }}
                </button>
            </div>
        </form>
    </ng-template>
</div>
